<app-error-detail [error]="error" [isComponent]="isComponent"></app-error-detail>
